const Header = require('./header'),
    scroll = require('./scroll')

require('./form')

$(function() {

  Header();

  // Nav

  $('nav.menu a').on('click', function (event) {
    event.preventDefault();

    const href = $(this).attr('href'),
        $target = $(href);

    scroll.animate($target, 600, function(){
      window.location.hash = href;
    });

    return false;
  });
});
